import FormQualifierAttribute, {
  IFormQualifierAttribute
} from "../../../model/form/FormQualifierAttribute";
import { formatBooleanValue } from "../../..";
import FormSectionQualifier, {
  IFormSectionQualifier
} from "../../../model/form/FormSectionQualifier";
import FormSection, { IFormSection } from "../../../model/form/FormSection";
import FormInputValue, {
  IFormInputValue
} from "../../../model/form/FormInputValue";
import FormSectionNestedList from "./FormSectionNestedList";

const AttributeMapper = (json = []) => {
  return json.map((item: any) => {
    let attribute = FormQualifierAttribute(item);
    attribute.labelVisible = formatBooleanValue(item.labelVisible);
    attribute.required = formatBooleanValue(item.required);
    return attribute;
  });
};

const QualifierMapper = (json = []) => {
  return json.map((item: any) => {
    let qualifier = FormSectionQualifier(item);
    qualifier.labelVisible = formatBooleanValue(item.labelVisible);
    qualifier.orderNumberVisible = formatBooleanValue(item.orderNumberVisible);
    qualifier.required = formatBooleanValue(item.required);
    return qualifier;
  });
};

const SectionMapper = (json = []) => {
  return json.map((item: any) => {
    let formSection = FormSection(item);
    formSection.labelVisible = formatBooleanValue(item.labelVisible);
    formSection.orderNumberVisible = formatBooleanValue(
      item.orderNumberVisible
    );
    formSection.required = formatBooleanValue(item.required);
    formSection.portalAggregate = formatBooleanValue(item.portalAggregate)
    return formSection;
  });
};

const ValueMapper = (json = []) => {
  return json.map((item: any) => {
    return FormInputValue({
      ...item,
      formSectionQualifierId: item.formSectionQualifierId,
      visible:
        item.visible !== undefined ? formatBooleanValue(item.visible) : true
    });
  });
};

function findAttributes(
  attributes: IFormQualifierAttribute[],
  qualifier: IFormSectionQualifier
) {
  const attributeList = attributes.filter(
    (attribute: IFormQualifierAttribute) =>
      attribute.qualifierId === qualifier.qualifierId
  );

  return JSON.parse(JSON.stringify(attributeList));
}

function findAttributeValues(
  values: IFormInputValue[],
  attribute: IFormQualifierAttribute,
  qualifier: IFormSectionQualifier
) {
  return values.filter((value: IFormInputValue) => {
    if (
      value.qualifierAttributeId === attribute.id &&
      value.formSectionQualifierId === qualifier.formSectionQualifierId
    ) {
      value.attribute = attribute;
      return true;
    }
    return false;
  });
}

function findQualifiers(
  qualifiers: IFormSectionQualifier[],
  formSection: IFormSection
) {
  return qualifiers.filter(
    (qualifier: IFormSectionQualifier) =>
      qualifier.formSectionId === formSection.id
  );
}

function groupElements(
  formSections: IFormSection[],
  qualifiers: IFormSectionQualifier[],
  attributes: IFormQualifierAttribute[],
  values: IFormInputValue[]
) {
  let sections = formSections.map((formSection: IFormSection) => {
    formSection.qualifiers = findQualifiers(qualifiers, formSection);

    formSection.qualifiers = formSection.qualifiers.map(
      (qualifier: IFormSectionQualifier) => {
        qualifier.attributes = findAttributes(attributes, qualifier);

        qualifier.attributes = qualifier.attributes.map(
          (attribute: IFormQualifierAttribute) => {
            let assignedValues = findAttributeValues(
              values,
              attribute,
              qualifier
            );
            attribute.values = assignedValues;
            return attribute;
          }
        );
        return qualifier;
      }
    );
    return formSection;
  });
  return sections;
}

const FormDetailsMapper = (
  sections: any,
  qualifiers: any,
  attributes: any,
  values: any
) => {
  let attributeMappedList = AttributeMapper(attributes);
  let qualifierMappedList = QualifierMapper(qualifiers);
  let sectionMappedList = SectionMapper(sections);
  let valueMappedList = ValueMapper(values);

  const formSectionFlatList = groupElements(
    sectionMappedList,
    qualifierMappedList,
    attributeMappedList,
    valueMappedList
  );

  return FormSectionNestedList(formSectionFlatList);
};

export default FormDetailsMapper;
